export default class Fixture {
  id?: number;
  group?: number;
  competitor1Id!: number;
  competitor2Id!: number;
  resultDate?: string;
  competitor1Score?: number;
  competitor2Score?: number;
}
